import type { IOpinionChartEventData } from '../types';

/** 情报事件库默认展示的事件类型 */
export const DEFAULT_OPINION_BUBBLE_EVENT_TYPES = [
  'version_release',
  'ingame_event',
  'marketing_campaign',
];

export function isDefaultOpinionBubbleEventType(eventType?: string): boolean {
  if (!eventType) {
    return false;
  }
  return DEFAULT_OPINION_BUBBLE_EVENT_TYPES.includes(eventType);
}

interface IBuildBubbleEventOptions {
  /** 仅包含指定事件类型；不传则包含全部 */
  eventTypes?: string[];
}

/** chartRenderEventList 生成 bubbleEvent */
export function buildBubbleEventFromChartRenderEventList(
  chartRenderEventList: IOpinionChartEventData['chartRenderEventList'] = {},
  options?: IBuildBubbleEventOptions,
): Record<string, any[]> {
  const allowedTypes =
    options?.eventTypes?.length
      ? new Set(options.eventTypes)
      : null;
  const result: Record<string, any[]> = {};

  Object.entries(chartRenderEventList || {}).forEach(([timeKey, payload]) => {
    const events: any[] = [];
    Object.values(payload?.event_list || {}).forEach(list => {
      if (!Array.isArray(list)) {
        return;
      }
      list.forEach(item => {
        if (!allowedTypes || allowedTypes.has(item?.event_type)) {
          events.push(item);
        }
      });
    });
    if (events.length) {
      result[timeKey] = events;
    }
  });

  return result;
}
